<template>
  <div id="app">
    <div class="block-cont">
        <div class="back1">
          <img src="./assets/BackSheet1.svg">
        </div>
        <div class="back2">
          <img src="./assets/BackSheet1.svg">
        </div>
    </div>
    <debug-panel v-if="config.ENV != 'production'"></debug-panel>
    <login-status></login-status>

    <div class="maincontent">
      <router-view></router-view>
    </div>

    <br/><br/>
    <div class="copyright">
      For legal, terms of service, privacy policy, or cookie policy <router-link to="legal">click here</router-link>
    </div>
    <ul class="copyright">
      <li>&copy; Copyright 2025 Swiftor, Inc.</li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'app',
  computed: {
    config () {
      return Vue.config
    }
  },
  mounted () {
    var s1 = document.getElementsByClassName('back1')[0]
    var s2 = document.getElementsByClassName('back2')[0]
    parallax()
    function parallax () {
      if (window.pageYOffset < window.innerWidth * 2) {
        s1.style.top = 40 + window.pageYOffset * (window.innerWidth * 0.000009) + '%'
        s2.style.top = 80 - window.pageYOffset * (window.innerWidth * 0.000007) + '%'
      }
    }
    window.addEventListener('scroll', function () {
      parallax()
    })
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
}
body {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #222222;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.link-footer a {
  color: #42b983;
}

.logo {
  text-decoration: none;
  color: black;
  font-size: 45px;
  font-weight: bold;
}

.copyright {
  font-size: 10px;
}
.user-cell {
  text-align: left;
}

.back1{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -100;
  overflow: hidden;
  max-height: 100%;
}
.back2{
  width: 100%;
  max-height: 100%;
  transform: scaleX(-1);
  position: absolute;
  top: 0;
  left: 0;
  z-index: -100;
  overflow: hidden;
}
.block-cont{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  overflow: hidden;
  z-index: -100;
}
</style>



// WEBPACK FOOTER //
// src/App.vue